import React, { Component } from 'react';

import { Http } from '../../support';
import Storage from '../../support/Storage';
import SupportMailForm from './SupportMailForm';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

class SendMailToSupport extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {}
    };
  }

  async componentDidMount() {
    const data = await Storage.get('facturotopia');

    const { cliente, user } = data;
    const { email } = cliente;
    const { nombre } = user;

    this.setState({
      data: {
        email: email,
        usuario: nombre
      }
    });
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    }

    this.setState({
      data
    });
  }

  handleOnClose = () => {
    this.props.history.replace('/app/dashboard');
  }

  handleOnSendMail = async () => {
    this.setState({
      busy: true,
    });

    const params = {
      ...this.state.data
    }

    try {
      const response = await Http.post(`app/send-mail-support`, params);

      this.setState({
        result: response
      });

    } catch (response) {
      this.setState({
        error: response.data || response
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Falló el envio del correo"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Correo enviado"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  handleOnAction = (action) => {
    this.props.history.replace('/app/dashboard');
  }

  render() {
    const { data, error, result } = this.state;

    if (result) {
      return this.renderResult();
    }

    if (error) {
      return this.renderError();
    }

    return (
      <SupportMailForm
        data={ data }
        email="soporte@waretek.mx"
        onChange={ this.handleOnChange }
        onClose={ this.handleOnClose }
        onSubmit={ this.handleOnSendMail } />
    )
  }
}

export default SendMailToSupport;
